import type { Worker } from '@/types/worker'

export const hasCosts = (worker: Worker): boolean => {
  return (
    parseFloat(worker.cost_gpu_hour) > 0 ||
    parseFloat(worker.cost_cpu_hour) > 0 ||
    parseFloat(worker.cost_1k_elements) > 0
  )
}
